import styled from "styled-components";
import { Box } from "@similarweb/ui-components";
import { InfoIcon } from "pro-features/components/BoxTitle/src/BoxTitle";
import { Title } from "@similarweb/ui-components";
import { colorsPalettes } from "@similarweb/styles";
import { LegendItems } from "pro-features/components/Legends/src/ComparePeriodsLegend/StyledComponents";
import { CenteredFlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

const ChartLegendContainer: any = styled.div`
    ${LegendItems} {
        margin-bottom: 20px;
    }
`;
ChartLegendContainer.displayName = "ChartLegendContainer";

const ChartContainer: any = styled.div``;
ChartContainer.displayName = "ChartContainer";

export const PoPChartContainer: any = styled.div`
    padding: 24px 24px 16px 24px;
    ${LegendItems} {
        margin-bottom: 20px;
    }
`;

const StyledHeaderTitle = styled(Title).attrs<{ "data-automation-box-title"?: boolean }>((props) => ({
    "data-automation-box-title": true,
}))`
    font-size: 20px;
    ${InfoIcon} {
        line-height: 1.55;
    }
`;

export const StyledBox = styled(Box)`
    height: ${({ height }) => height};
    display: flex;
    flex-direction: column;
    margin-bottom: 1.4rem;
`;

export const TitleContainer = styled(CenteredFlexRow)`
    padding: 24px 24px 20px 24px;
    border-bottom: 1px solid ${colorsPalettes.carbon["100"]};
    justify-content: space-between;
`;
